import React, {useState, useEffect} from "react";
import {  banner } from "../../components/imagepath";
import { hooks } from "../../studentportal-sdk";
import { Controller, useForm } from "react-hook-form";
import { Eye, EyeOff } from "react-feather/dist";

const ResetPassword = (props) => {
    const [passwordVisible, setPasswordVisible] = useState(false)

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
      };

  const {
    /**
     * authentication service
     */
    authService: {
      action: {resetPassword},
    },
    history
  } = props;

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    // resolver: yupResolver(schema),
  });

  const token = new URLSearchParams(history.location.search).get("token") || ''

  const onSubmit = (data) => {
    resetPassword({...data, token, logOtherDevicesOut: false});
  };



  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <div className="loginbox">
              <div className="login-left">
              <img className="img-fluid" src={banner} alt="Logo" />
              </div>
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Reset Password Request</h1>
                  <p className="account-subtitle">Let Us Help You</p>
                  {/* Form */}
                  <form onSubmit={handleSubmit(onSubmit)}>
                 
                    <div className="form-group">
                      <label>
                        Enter your New Password{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="password"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <div className="pass-group">
                            <input
                              type={passwordVisible ? "password" : "text"}
                              className={`form-control  ${
                                errors?.password ? "error-input" : ""
                              }`}
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                              placeholder="password"
                            />
                          </div>
                        )}
                        // defaultValue="Aj@123456"
                      />
                      <small>{errors?.password?.message}</small>
                      <span
                        className="toggle-password"
                        onClick={togglePasswordVisibility}
                      >
                        {passwordVisible ? (
                          <EyeOff className="react-feather-custom" />
                        ) : (
                          <Eye className="react-feather-custom" />
                        )}
                      </span>
                    </div>
                    <div className="form-group">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                      >
                        Send Request
                      </button>
                    </div>
                    {/* <div className="form-group mb-0">
                      <button
                        className="btn btn-primary primary-reset btn-block"
                        type="submit"
                        onClick="./admindashboard"
                      >
                        Login
                      </button>
                    </div> */}
                  </form>
                  {/* /Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
/* eslint-disable */

export default (props) => <ResetPassword  {...hooks.authentication(props)}/>;
